import React from "react";
import styles from "./style.module.sass"

export const Blinking: React.FC<{}> = (props) => {

    return <div className={styles.blinking}>
        {props.children}
    </div>
}
